export const createAccountApplication = `
    mutation createAccountApplication($input: CreateAccountApplicationInput!) {
        createAccountApplication(input:$input) {
          id
          accountId
          applicationId
          application {
              id 
              name
          }
          accountApplicationStatus
    }
}`;

export const updateAccountApplication = `
    mutation updateAccountApplication($input: UpdateAccountApplicationInput!) {
        updateAccountApplication(input:$input){
              id
              accountId
              applicationId
              application {
                  id 
                  name
              }
              accountApplicationStatus
        }
}`;

export const deleteAccountApplication = `
    mutation deleteAccountApplication($input: DeleteAccountApplicationInput!) {
        deleteAccountApplication(input:$input) {
            id
        }
}`;
